module.exports = __webpack_public_path__ + "static/media/pizza.71e499ea.jpg";